import React from 'react'

const ShimmeringEffect = () => {
  return (
    <div className='pvv-card pvv-skeleton-gray'>
      <div className='pvv-icon pvv-skeleton-white'></div>
    </div>
  )
}

export default ShimmeringEffect
